import { ChangeDetectionStrategy, Component, inject, NgZone, OnDestroy, OnInit, signal } from '@angular/core';

import { BaseComponent } from '../../../core/abstractions/base.component';
import { ChatMessageModel } from '../../../models/chat-message.model';
import { SignalRChannelEnum } from '../../../models/enums/signalr-channel.enum';
import { GeneralMeetingsResource } from '../../../services/resources/general-meetings.resource';
import { SignalRService } from '../../../services/signalr.service';
import { SecurityStorage } from '../../../services/storage/security.storage';

@Component({
    selector: 'sl-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatComponent extends BaseComponent implements OnInit, OnDestroy {
    messages = signal<ChatMessageModel[]>([]);

    private readonly ngZone = inject(NgZone);
    private readonly generalMeetingsResource = inject(GeneralMeetingsResource);
    private readonly signalRService = inject(SignalRService);
    private readonly securityStorage = inject(SecurityStorage);

    ngOnInit(): void {
        this.loadChat();

        const msgSub = this.signalRService.onMessageReceived.subscribe(() => this.ngZone.run(() => this.loadChat()));
        const shareholderId = this.securityStorage.getUserInfo()?.shareholderId?.toString() ?? '';

        this.signalRService.startConnection(SignalRChannelEnum.Chat, shareholderId);
        this.addSubscriptions(msgSub);
    }

    loadChat(): void {
        this.generalMeetingsResource.getCurrentChat().subscribe(r => this.messages.set(r.value));
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.signalRService.stopConnection();
    }
}
